import { render, staticRenderFns } from "./StateSale.vue?vue&type=template&id=748ffd8b&scoped=true&"
import script from "./StateSale.vue?vue&type=script&lang=js&"
export * from "./StateSale.vue?vue&type=script&lang=js&"
import style0 from "./StateSale.vue?vue&type=style&index=0&id=748ffd8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ffd8b",
  null
  
)

export default component.exports